import { Card, Skeleton, Group, Stack } from '@mantine/core';

interface TopOffendingSkeletonProps {
  title: string;
  itemCount?: number;
}

/**
 * Skeleton loading component for top offending data cards
 * @param title - Title for the skeleton card
 * @param itemCount - Number of skeleton items to show
 */
export function TopOffendingSkeleton({ title: _title, itemCount = 3 }: TopOffendingSkeletonProps): JSX.Element {
  return (
    <Card shadow="sm" padding="lg" radius="md" withBorder>
      <Group justify="space-between" mb="md">
        <Skeleton height={16} width="60%" />
        <Skeleton height={20} width={20} radius="50%" />
      </Group>
      
      <Stack gap="xs">
        {Array.from({ length: itemCount }).map((_, index) => (
          <Group key={index} justify="space-between" p="xs" style={{ 
            backgroundColor: 'var(--mantine-color-gray-0)', 
            borderRadius: 'var(--mantine-radius-sm)' 
          }}>
            <Group gap="xs">
              <Skeleton height={20} width={24} radius="sm" />
              <Skeleton height={16} width="70%" />
            </Group>
            <Skeleton height={20} width={60} radius="sm" />
          </Group>
        ))}
      </Stack>
    </Card>
  );
}
